module.exports = __webpack_public_path__ + "static/media/clases-online.54b95762.jpg";